import { createSlice } from "@reduxjs/toolkit";
import K from "utilities/constants";
import { keyBy, pick } from "lodash";

const { Redux } = K;

const CandidatePropsToUpdate = [
  "candidate",
  "status",
  "statusId",
  "subStatus",
  "subStatusId",
  "otherStatus",
  "otherStatusId",
  "candidateStatus",
  "candidateStatusId",
  "isConsiderable",
];

const initialState = {
  [Redux.Listing]: [],
  [Redux.ShouldUpdate]: false,
  [Redux.ShouldReinitialize]: false,
  uploadedCandidate: [],
};

export const candidateSlice = createSlice({
  name: "candidates",
  initialState,
  reducers: {
    setCandidateList: (state, action) => {
      state[Redux.Listing] = action.payload;
    },
    updateCandidateList: (state, action) => {
      state[Redux.ShouldUpdate] = !state[Redux.ShouldUpdate];
      const currentList = Array.isArray(state[Redux.Listing])
        ? state[Redux.Listing]
        : [];

      state[Redux.Listing] = [...currentList, action.payload];
    },
    removeFromCandidateList: (state, action) => {
      state[Redux.ShouldUpdate] = !state[Redux.ShouldUpdate];

      state[Redux.Listing] = Array.isArray(state[Redux.Listing])
        ? state[Redux.Listing].filter((item) => item.id !== action.payload)
        : [];
    },
    editCandidateList: (state, action) => {
      state[Redux.ShouldUpdate] = !state[Redux.ShouldUpdate];
      state[Redux.Listing] = state[Redux.Listing].map((item) => {
        return item.id === action.payload.id
          ? { ...item, ...pick(action.payload, CandidatePropsToUpdate) }
          : item;
      });
    },
    bulkEditCandidateList: (state, action) => {
      const updates = action.payload;
      const updatesById = keyBy(updates, "id");

      state[Redux.ShouldUpdate] = !state[Redux.ShouldUpdate];

      state[Redux.Listing] = state[Redux.Listing].map((item) => {
        const updated = updatesById[item.id];
        return updated
          ? { ...item, ...pick(updated, CandidatePropsToUpdate) }
          : item;
      });
    },
    setShouldReinitialize: (state) => {
      state[Redux.ShouldReinitialize] = !state[Redux.ShouldReinitialize];
    },
    setShouldUpdate: (state) => {
      state[Redux.ShouldUpdate] = !state[Redux.ShouldUpdate];
    },
    setUploadCandidate: (state, action) => {
      state.uploadedCandidate = action.payload;
    },
  },
});

export const selectCandidates = (state) => state.candidates;
export const {
  setCandidateList,
  editCandidateList,
  bulkEditCandidateList,
  updateCandidateList,
  setShouldReinitialize,
  setShouldUpdate,
  setUploadCandidate,
  removeFromCandidateList,
} = candidateSlice.actions;

export default candidateSlice.reducer;
